;(function() {
    
    /** map footer **/
    function initMap() {
        var adresse = new google.maps.LatLng(45.78577, 4.782105300000012);
        var map = new google.maps.Map(document.getElementById('map'), {
            center: adresse,
            zoom: 16
        });

        marker = new google.maps.Marker({
            position : map.getCenter(),
            map      : map,
            icon: $uri+"/assets/dist/images/marker.png",
            animation: google.maps.Animation.DROP
        });
    }

    $(document).ready(function(){
        $('#menu-main-nav').each(function() {
            var $menu = $(this);
            $menu.find('li.active').each(function() {
                $(this).parentsUntil($menu).addClass('active');
            });
        });
        if($("body").hasClass("page-template-contact")){
            initMap();
        }

        $('.owl-carousel').owlCarousel({
            loop:true,
            margin:10,
            dots:true,
            nav:true,
            items : 1,
            autoplay:true,
            autoplayTimeout:3000
        });
    });


})(jQuery);